<template>
    <div class="digital-classrooms-signup__table">
        <div class="digital-classrooms-signup__table-row digital-classrooms-signup__headers">
            <div class="digital-classrooms-signup__table-cell" v-html="$t('DigitalClassrooms.date')"></div>
            <div class="digital-classrooms-signup__table-cell digital-classrooms-signup__timezone">
                <span v-html="$t('DigitalClassrooms.time')"></span>
                <span class="digital-classrooms-signup__timezone-icon icon-info-solid" v-tooltip="{ content: getCurrentTimeZone, html: true }"></span>
            </div>
            <div class="digital-classrooms-signup__table-cell" v-html="$t('DigitalClassrooms.duration')"></div>
            <template v-if="isDesktopView">
                <div v-if="!pastEventsTable" class="digital-classrooms-signup__table-cell" v-html="$t('DigitalClassrooms.seats')"></div>
                <div v-else class="digital-classrooms-signup__table-cell"></div>
                <div v-if="hasAccessToSignUp || userHasNoAccessButHasSignup" class="digital-classrooms-signup__table-cell --signup-button"></div>
            </template>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'DigitalClassRoomTable',
        props: {
            hasAccessToSignUp: Boolean,
            userHasNoAccessButHasSignup: Boolean,
            pastEventsTable: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            getCurrentTimeZone () {
                return `${this.$t('DigitalClassrooms.timezone')}: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`
            }
        }
    }
</script>

<style lang="scss" scoped>
    @include digital-classrooms-table;
    .digital-classrooms-signup {
        &__table {
            display: flex;
            flex-direction: column;
            border: solid 1px $alto;
            overflow: hidden;
            border-radius: 10px;
        }
        &__headers {
            color: $tuatara;
            background: $concrete;
            border-radius: 10px 10px 0 0;
            min-height: 60px;
            font-size: 1.6rem;
            font-family: PlusJakartaSans-Bold, sans-serif;

            [class*="mobile"] & {
                background: $white !important;
                padding: 8px 4px;
            }
        }
        &__timezone {
            display: flex;
        }
        &__timezone-icon {
            margin-left: 5px;
            font-size: 1.6rem;
        }
    }
    .digital-classrooms-event {
        &:nth-child(odd) {
            background-color: $very_light_blue;
        }

        &:nth-child(even) {
            background-color: $white;
        }

        &__signed {
            &:nth-child(odd),
            &:nth-child(even) {
                background-color: $light_green;
            }
        }
    }
</style>
